import React from 'react';
import { Sparkles, ExternalLink } from 'lucide-react';
import { VISUAL_EDITOR_ENABLED } from '../../config/featureFlags';

// PreviewReadyBanner — Sprint C item 2.7. Surfaces on Portal Overview when
// the principal's project is in 'preview_review' status. Hidden when no
// preview state is provided (default render returns null).
//
// Sprint D's full Overview redesign replaces this with a richer card; for
// Sprint C the banner gets the principal looking at their preview before any
// other portal content.

export default function PreviewReadyBanner({ state }) {
  if (!state || state.project_status !== 'preview_review') return null;
  return (
    <div
      className="mb-6 px-4 py-4 rounded-2xl border border-[#B0FC38]/30 bg-gradient-to-r from-[#B0FC38]/[0.10] to-transparent flex items-center gap-4 flex-wrap"
      data-testid="preview-ready-banner"
    >
      <div className="w-10 h-10 rounded-full bg-[#B0FC38]/15 flex items-center justify-center shrink-0">
        <Sparkles className="w-5 h-5 text-[#B0FC38]" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="text-[14px] font-semibold text-white">Your preview is ready</div>
        <div className="text-[12px] text-gray-300 mt-0.5">
          {VISUAL_EDITOR_ENABLED
            ? 'Review the new site and submit any change requests via the Visual Editor.'
            : 'Review the new site and submit any change requests on the Content Edits page.'}
        </div>
      </div>
      {state.url && (
        <a
          href={state.url}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="preview-ready-banner-link"
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full bg-[#B0FC38] text-gray-900 text-[13px] font-semibold hover:bg-[#9BE22E] transition-colors"
        >
          Open preview <ExternalLink className="w-3.5 h-3.5" />
        </a>
      )}
    </div>
  );
}
